/**
 * Determines whether the global OAuth code-grant flow should run for the
 * current route.
 *
 * Some non-auth routes (e.g. offline-notification verify/unsubscribe) also use
 * a `code` query param for a different purpose. The code-grant handler must not
 * treat those codes as OAuth authorization codes.
 *
 * @param pathname - The current location pathname (e.g. window.location.pathname)
 * @returns false when the route uses `code` for a non-auth purpose, else true
 */
export const shouldProcessCodeGrant = (pathname: string): boolean => {
  if (pathname.startsWith('/offline-notifications')) {
    return false
  }
  return true
}
